'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImageFrame = function () {
  function ImageFrame(element, args) {
    _classCallCheck(this, ImageFrame);

    this.img = document.createElement('img');
    this.img.src = args.image ? args.image : '';

    var fragment = document.createDocumentFragment();
    fragment.appendChild(this.img);

    if (element) {
      element.appendChild(fragment);
    }
  }

  _createClass(ImageFrame, [{
    key: 'getImage',
    value: function getImage() {
      return this.img.src;
    }
  }, {
    key: 'setImage',
    value: function setImage(image) {
      this.img.src = image ? image : '';
    }
  }, {
    key: 'getElement',
    value: function getElement() {
      return this.img;
    }
  }]);

  return ImageFrame;
}();

exports.default = ImageFrame;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/ImageFrame.js
// module id = 23
// module chunks = 0